module.exports = __webpack_public_path__ + "img/Group.d1f07b9b.png";